module.exports = __webpack_public_path__ + "img/img_form_name_order.c88abd88.png";